import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type PageTitles = {
  [key: string]: string;
};

export const usePageTitle = (defaultTitle: string, pageTitles?: PageTitles) => {
  const location = useLocation();
  const path = location.pathname.split('/').pop() || '';

  useEffect(() => {
    const previousTitle = document.title;
    
    if (pageTitles && path in pageTitles) {
      document.title = pageTitles[path];
    } else {
      document.title = `${defaultTitle} | JLS Apps`;
    }

    return () => {
      document.title = previousTitle;
    };
  }, [defaultTitle, pageTitles, path]);
};
